import React, { useState } from "react";
import { MediaCard, Modal, VideoThumbnail } from "@shopify/polaris";
import ReactPlayer from "react-player/youtube";
import VideoThumbnailImg from "../Images/video_thumb.png";

function Video() {
    const [videoModal, setvideoModal] = useState(false);
    return (
        <div>
            <MediaCard
                title="Getting started with Smart Account Activate"
                primaryAction={{
                    content: "Learn more..",
                    onAction: () => {
                        setvideoModal(true);
                    },
                }}
                description="Watch this to learn more about how you can update the activation section that appears on the order confirmation page of your buyers."
            >
                <VideoThumbnail
                    onClick={() => {
                        setvideoModal(true);
                    }}
                    videoLength={80}
                    thumbnailUrl="https://burst.shopifycdn.com/photos/business-woman-smiling-in-office.jpg?width=1850"
                />
            </MediaCard>
            {videoModal && (
                <Modal
                    // activator={activator}
                    open={videoModal}
                    large={true}
                    onClose={() => setvideoModal(false)}
                >
                    <Modal.Section>
                        <ReactPlayer
                            url="https://www.youtube.com/watch?v=9AP9X_SrvL8"
                            playing={true}
                            controls={true}
                            width="100%"
                            height="460px"
                            className="videoClose"
                        />
                    </Modal.Section>
                </Modal>
            )}
        </div>
    );
}

export default Video;
